<!-- 行业内参--详情-->
<template>
  <div class="site-content" v-if="detail">
    <div class="site-content-banner banner-customer">
      <div class="site-content-page  banner-customer">
        <div class="content-row">
          <div class="info-detail-title-1">
            <div class="title-img">
              <img :src="detail.cover_img"/>
            </div>
            <div class="div-1-1">{{ detail.name }}</div>
            <div class="div-1-2">
              {{ detail.intro&&detail.intro.length > labelLength ? (detail.intro.replace(/<[^>]*>/g, '').substring(0, labelLength) + '...') : detail.intro.replace(/<[^>]*>/g, '') }}
            </div>
            <div class="div-1-4">
              <table class="div-1-4-table" cellpadding="2" cellspacing="0">
                <tr>
                  <td class="td-title">总期数</td>
                  <td class="td-title">当前更新</td>
                  <td class="td-title">产品方式</td>
                  <td class="td-title">产品价格</td>
                  <td rowspan="2" class="td-action"><a class="td-action-1">立即购买</a></td>
                </tr>
                <tr>
                  <td class="td-value">{{ detail.data_volume }}</td>
                  <td class="td-value">{{ detail.current_count }}期</td>
                  <td class="td-value">{{ detail.price }}电子版</td>
                  <td class="td-value price">{{ detail.price }}</td>
                </tr>
              </table>
            </div>
            <div class="div-3">
              <div class="div-3-1">免费咨询</div>
              <div class="div-3-2"><img src="./../../assets/hync_er.png">
                <div>微信扫码在线咨询</div>
              </div>
              <div class="div-3-3">电话：0871-65137819</div>
              <div class="div-3-4">邮箱：wh@weihengvc.com</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="site-content-page">
      <div class="content-row">
        <div class="content-col">
          <div class="info-list-title">
            <span>内参详情</span>
          </div>
          <div class="info-detail-content">
            <p v-html="detail.intro"></p>
          </div>
        </div>

      </div>
      <div style="display: flex;align-items: center;justify-content: center;margin-top: 30px;">
        <a style="font-size: 18px;" target="_blank" :href="'https://yunguowang.weihengag.com/home/reference/detail/id/'+detailId+'html'">点击查看完整内参内容</a>
      </div>
    </div>
  </div>
</template>

<script>
import InfoPageList01 from '../block/InfoPageList01'
import InfoList04 from '../block/InfoList04'
import InfoDetail01 from '../block/InfoDetail01'

export default {
  name: 'Detail03',
  components: {
    'infoDetail-01': InfoDetail01,
    'infoList-04': InfoList04,
  },
  data() {
    return {
      detailId:0,
      msg: '',
      detail: {},
    }
  },
  methods: {
    detail_Req(detailId) {
      let that = this
      let params = {id: detailId}
      console.log('请求', params)
      that.$dataApi.referenceDetail(params).then(res => {
        console.log('内容', res)
        that.msg = res.msg
        that.detail = res.data
        // console.log('结束请求Vue-axios：'+JSON.stringify(that.detailInfo))
      })
    }
  },
  created: function () {
    let that = this;
    let detailId = that.$route.params.id;
    this.detailId=detailId
    that.detail_Req(detailId);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow: 3;
}

.col-per-30 {
  flex-grow: 1;
}

.banner-customer {
  background-color: #404040;
}

.info-detail-title-1 {
  position: relative;
  width: 100%;
  height: 280px;
  padding: 20px 200px 20px 190px;
  margin-top: -20px;
  margin-bottom: 0px;
  border-bottom: 0px;
  text-align: left;
//background:red;
}

.info-detail-title-1 .title-img {
  position: absolute;
  left: 0;
  width: 180px;
  height: 240px;
  text-align: left;
  background: #ddd;
}

.info-detail-title-1 .title-img img {
  float: left;
  width: 180px;
  height: 240px;
}

.info-detail-title-1 .title-info {
  float: left;
  width: calc(100% - 440px);
  text-align: left;
}

.info-detail-title-1 .title-act {
  float: left;
  width: 200px;
  height: 80px;
  text-align: center;
  line-height: 80px;
}

.info-detail-title-1 .title {
  padding: 5px 5px 5px 20px;
  height: 70px;
  font-size: 16px;
  font-weight: 800;
  line-height: 30px;
  text-align: left;
}

.title-detail-table {
  padding-left: 20px;
  font-size: 12px;
  line-height: 20px;
  color: #555555;
}

.title-detail-table .td-value {
  padding-left: 20px;
  color: var(--color6);
}

.info-detail-title-1 .collection {
  text-decoration: none;
  padding-right: 10px;
  padding-left: 20px;
  font-size: 12px;
  font-weight: 400;
  line-height: 40px;
  text-align: left;
  color: #9FA2A6;
  background-image: url(./../../assets/collection.png);
  background-size: 18px 18px;
  background-repeat: no-repeat;
  background-position: 0px 0px;
}

.info-detail-title-1 .share {
  text-decoration: none;
  padding-right: 10px;
  padding-left: 20px;
  font-size: 12px;
  font-weight: 400;
  line-height: 40px;
  text-align: left;
  color: #9FA2A6;
  background-image: url(./../../assets/share.png);
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: 0px 0px;
}

.info-detail-zh-other {
  list-style-type: none;
  padding: 20px;
  font-size: 12px;
  background: #eee;
}

.info-detail-zh-other li {
  margin: 0px 0px 2px 0px;
  padding: 4px;
  height: 20px;
  text-align: left;
}

.info-detail-zh-other .label {
  margin: 0px 0px 2px 0px;
  padding: 4px;
  height: 20px;
  text-align: left;
  color: #888;
}

.info-detail-zh-other .value {
  position: relative;
  margin: 0px 0px 2px 0px;
  padding: 4px;
  height: 100%;
  text-align: left;
  color: #000;
}

.div-1-1 {
  position: relative;
  float: left;
  font-size: 18px;
  line-height: 40px;
  color: #fff;
}

.div-1-2 {
  position: relative;
  float: left;
  font-size: 12px;
  line-height: 20px;
  color: #fff;
}

.div-3 {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 170px;
  height: 170px;
  margin: 15px 20px 15px 0px;
  padding-left: 10px;
  border-left: 1px solid #bbb;
//background:yellow; color: #888;
}


.div-3-1 {
  position: relative;
  text-align: center;
  font-weight: 600;
  color: #000;
}

.div-3-2 {
  margin: 0px auto;
  width: 110px;
  border: 5px solid #fff;
  background: #fff;
  text-align: center;
}

.div-3-2 img {
//width:90px; //height:90px;
}

.div-3-3 {
  position: relative;
  text-align: center;
}

.div-3-4 {
  position: relative;
  text-align: center;
}

.div-1-4 {
  position: relative;
  float: left;
  width: 100%;
  padding: 10px 0px 0px 0px;
}


.div-1-4-table {
  width: 100%;
}

.div-1-4-table .td-title {
  text-align: left;
  color: #888;
}

.div-1-4-table .td-value {
  text-align: left;
  font-size: 16px;
  line-height: 30px;
  color: #fff;
}

.div-1-4-table .price {
  text-align: left;
  font-size: 16px;
  line-height: 30px;
  color: #fff;
}

.div-1-4-table .price:before {
  content: "\00A5";
  font-size: 14px;
  color: #fff;
}

.div-1-4-table .td-action {
  text-align: center;
}

.td-action .td-action-1 {
  height: 30px;
  width: 100px;
  padding: 5px 15px 5px 15px;
  margin-left: 10px;
  background-color: var(--color2);
  color: #fff;

}

.td-action .td-action-2 {
  height: 30px;
  width: 100px;
  padding: 5px 15px 5px 15px;
  margin-left: 10px;
  background-color: var(--color6);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Detail03.vue